export default {
  SET_URL: 'IMAGE_UPLOADER/SET_URL',
  UPLOAD_FILE: 'IMAGE_UPLOADER/UPLOAD_FILE',
  UPLOAD_FILE_SUCCESS: 'IMAGE_UPLOADER/UPLOAD_FILE_SUCCESS',
  UPLOAD_FILE_FAILURE: 'IMAGE_UPLOADER/UPLOAD_FILE_FAILURE',
}
